import CONST from '@/globals/constants'
import _ from 'lodash'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'mediaSearchBar',
  inject: [
    '$currentUser',
    '$utils',
    '$filtersRepository'
  ],
  props: {
    isMediaAlertTypeProp: {
      type: Boolean,
      default () { return false }
    }
  },
  watch: {
    isMediaAlertTypeProp (newVal) {
      this.isMediaAlertType = newVal
      this.setDefaultData()
    }
  },
  data () {
    return {
      mediaTypes: [
        {
          name: CONST.MEDIA_TYPE_NAME_IMAGE,
          tName: this.$t('filters.images'),
          value: CONST.MEDIA_TYPE_VALUE_IMAGE
        },
        {
          name: CONST.MEDIA_TYPE_NAME_VIDEO,
          tName: this.$t('filters.videos'),
          value: CONST.MEDIA_TYPE_VALUE_VIDEO
        },
        {
          name: CONST.MEDIA_TYPE_NAME_AUDIO,
          tName: this.$t('filters.audio'),
          value: CONST.MEDIA_TYPE_VALUE_AUDIO
        },
        {
          name: CONST.MEDIA_TYPE_NAME_PROJECT,
          tName: this.$t('filters.projectsOrPdf'),
          value: CONST.MEDIA_TYPE_VALUE_PROJECT
        },
        {
          name: CONST.MEDIA_TYPE_NAME_SCHEDULED,
          tName: this.$t('filters.scheduled'),
          value: CONST.MEDIA_TYPE_VALUE_SCHEDULED
        }
      ],
      isSearchIconVisible: false,
      isSearchInputVisible: false,
      isMediaAlertType: this.isMediaAlertTypeProp,
      showSearchInput: false,
      searchTextVal: '',
      selectedMediaTypes: []
    }
  },
  mixins: [],
  methods: {
    emitEvent (action, data) {
      if (!_.isEmpty(action)) {
        _.delay(() => {
          this.$emit('media-search-bar-change', { action, payload: { data } })
        }, 10)
      }
    },
    setDefaultData () {
      // Set default value for searchText and mediaType from filtersReporitory
      if (!_.isEmpty(this.$filtersRepository.findSearchText()) || !_.isEmpty(this.$filtersRepository.findMediaTypes())) {
        this.setSearchTextVal(this.$filtersRepository.findSearchText())
        this.setSelectedMediaTypes(this.$filtersRepository.findMediaTypes())
      }

      // Set Search Icon or Search Input is Visible
      if (!_.isEmpty(this.searchTextVal)) {
        this.isSearchIconVisible = false
        this.isSearchInputVisible = true
      } else {
        this.isSearchIconVisible = true
        this.isSearchInputVisible = false
      }

      // Remove Audio Media type filter if user is not extended
      const isUserNotExtended = !this.$currentUser.hasGroupExtended()
      const isUserExtendedButWithoutAdmindOrCreateRights = this.$currentUser.hasGroupExtended() && !this.$currentUser.hasGroupUserAdmin() && !this.$currentUser.hasGroupUserCreate() && !this.$currentUser.hasGroupUserCreateLock()
      const isComponentUsedInAlertPage = this.isMediaAlertType
      if (isUserNotExtended || isUserExtendedButWithoutAdmindOrCreateRights || isComponentUsedInAlertPage) {
        this.mediaTypes = this.mediaTypes.filter(t => t.value !== CONST.MEDIA_TYPE_VALUE_AUDIO)
      }

      // Remove Scheduled Media type filter in Alert Page
      if (isComponentUsedInAlertPage) {
        this.mediaTypes = this.mediaTypes.filter(t => t.value !== CONST.MEDIA_TYPE_VALUE_SCHEDULED)
      }
    },
    handleSearchIconClick () {
      this.isSearchIconVisible = false
      this.isSearchInputVisible = true
      this.$nextTick(_ => {
        this.$refs.mediaSearchInput.focus()
      })
      useMixpanel().track('Search clicked')
    },
    setSearchTextVal (searchText = '') {
      this.searchTextVal = searchText
      this.$filtersRepository.saveSearchText(searchText)
    },
    setSelectedMediaTypes (mediaTypes = []) {
      this.selectedMediaTypes = mediaTypes
      this.$filtersRepository.saveMediaTypes(mediaTypes)
    },
    handleMediaTypeClick ($event = {}, mediaType = '') {
      let selectedMediaTypesData = this.selectedMediaTypes

      if (!this.selectedMediaTypes.includes(mediaType)) {
        if (!this.$utils.isCtrlKeyPressed($event)) {
          selectedMediaTypesData = []
        }

        selectedMediaTypesData.push(mediaType)

        // Add elementi if project is present
        if (mediaType === CONST.MEDIA_TYPE_VALUE_PROJECT) {
          selectedMediaTypesData.push(CONST.MEDIA_TYPE_VALUE_ELEMENTI)
        }

        // Add project-audio if audio is present
        if (mediaType === CONST.MEDIA_TYPE_VALUE_AUDIO) {
          selectedMediaTypesData.push(CONST.MEDIA_TYPE_VALUE_AUDIO_PLAYLIST)
        }
      } else {
        selectedMediaTypesData = selectedMediaTypesData.filter(m => m !== mediaType)

        // Remove elementi if project
        if (mediaType === this.mediaTypes.MEDIA_TYPE_VALUE_PROJECT) {
          selectedMediaTypesData = selectedMediaTypesData.filter(m => m !== CONST.MEDIA_TYPE_VALUE_ELEMENTI)
        }

        // Remove project-audio if audio
        if (mediaType === CONST.MEDIA_TYPE_VALUE_AUDIO) {
          selectedMediaTypesData = selectedMediaTypesData.filter(m => m !== CONST.MEDIA_TYPE_VALUE_AUDIO_PLAYLIST)
        }

        if (!this.$utils.isCtrlKeyPressed($event)) {
          selectedMediaTypesData = []
        }
      }

      this.setSelectedMediaTypes(selectedMediaTypesData)
      this.emitEvent(CONST.EMIT_EVENT_SELECTED_MEDIA_TYPES_CHANGED, selectedMediaTypesData)
    },
    handleSearchTextConfirmation (searchTextVal = '') {
      this.setSearchTextVal(searchTextVal)

      if (!_.isEmpty(searchTextVal)) {
        this.emitEvent(CONST.EMIT_EVENT_SEARCH_TEXT_CHANGED_ENTER, searchTextVal)
      } else {
        this.isSearchInputVisible = false
        this.isSearchIconVisible = true
      }
    },
    handleSearchInputOnKeyup () {
      if (!this.$refs.mediaSearchBar) return

      let timer = null
      this.$refs.mediaSearchBar.onkeyup = () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.setSearchTextVal(this.searchTextVal)
          this.emitEvent(CONST.EMIT_EVENT_SEARCH_TEXT_CHANGED_TYPING, this.searchTextVal)
        }, 2000)
      }
    }
  },
  mounted () {
    this.setDefaultData()
    this.handleSearchInputOnKeyup()
  }
}
